import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqList } from '@/mocks/comics';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            {t('home.faq_title')}
          </h2>
          <p className="text-sm text-foreground-600">{t('home.faq_subtitle')}</p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-60 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}